import { emailValidations } from './emailValidations';

export const workspace = $axios => ({
  emailValidations: emailValidations($axios),
});
